import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import './design-guidelines-styles.css';
export const _frontmatter = {
  "pageTitle": "Tooltip Design Guidelines",
  "title": "Tooltip",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PageContent componentName="tooltip" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  Tooltips display informative text when users hover over, or focus on an
  element.
      </LeadParagraph>
      <h2>{`Usage`}</h2>
      <p>{`Tooltips are necessary for interactive elements whose function may not be clearly spelled out within the element itself. This is especially valuable for elements that are represented only by an image or icon. Tooltips should always be paired closely with the element with which they are associated. The message within the tooltip should always be kept as short and clear as possible.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "69.88416988416989%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAm0lEQVQoz83SQQrCMBAF0JwuvZl3UawRXHiBbHqDLgSpmL2dP20zLWSErqO0utC/f/zPMKb7IuYvMcAAf4KZu2mScRRmXot5GOK2vOyPV4kv/ZvZw+l835V121Lf9+swEZrmVlVVCCHGmC03OUaq6tzB2sLawjmnqkS0CANIKXnvN3O89yklAEtnM7OI6ByR9QcD8JiT7fz1ez4BCpwXpcdOnxEAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.1/static/913562385fde71df7ad247168ac42d33/8ae3e/Tooltip-imagery.png",
                  "srcSet": ["/version/4.9.1/static/913562385fde71df7ad247168ac42d33/a2ead/Tooltip-imagery.png 259w", "/version/4.9.1/static/913562385fde71df7ad247168ac42d33/6b9fd/Tooltip-imagery.png 518w", "/version/4.9.1/static/913562385fde71df7ad247168ac42d33/8ae3e/Tooltip-imagery.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-correct"
                }}>{`Correct`}</p>{`
          `}<p parentName="figcaption">{`Use tooltips for interactive imagery like icon buttons.`}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "69.88416988416989%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA70lEQVQoz7XSsWoCQRAG4HsZ6xSWeQKNjelCurSpTGNxQhTyKiEuFukCgUiEw1XBB7AS8QpNs5iZcfaOPR2JhUI48cTkZ9qvmPnHW54R7+8xEX3DfogoKyZaRhGLxLuJIk7lXoq0PP9aBDoMutNAh50gnM0Xqf43BiAR99Ia5S6a1zfvhfJb/vK59ToScQB0BCOSSNzuTG7vPivV/v2Dfnz66PXH61WMSMd3RsQkSQaDoV9r+H5d66FzCRFmOhgAiIhSqlS6KhYLSjVFBACyVsXMxpjpT0JjDDOf1rO11m1jrT2h553HbQ7J/3nPjHgDKDIKycKZGP0AAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.9.1/static/47f0ff2e8061205c412ced569361a910/8ae3e/Tooltip-repeat-word.png",
                  "srcSet": ["/version/4.9.1/static/47f0ff2e8061205c412ced569361a910/a2ead/Tooltip-repeat-word.png 259w", "/version/4.9.1/static/47f0ff2e8061205c412ced569361a910/6b9fd/Tooltip-repeat-word.png 518w", "/version/4.9.1/static/47f0ff2e8061205c412ced569361a910/8ae3e/Tooltip-repeat-word.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-incorrect"
                }}>{`Incorrect`}</p>{`
          `}<p parentName="figcaption">{`Don’t use tooltips to restate visible UI text.`}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
  `}</div>
      </div>
      <hr></hr>
      <h2>{`Placement`}</h2>
      <p>{`Tooltips can be positioned below, above, to the right of, or to the left of the element they are associated with. The tooltip will automatically adjust its position to ensure it stays within the visible area of your browser window.`}</p>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "25.096525096525095%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAIAAADKYVtkAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA60lEQVQY0z3QvU/DMBAF8PzbSGxZaIYODFRiKULpjgQbO5FIN4YkVVmgyBjir/jubMdIRkkLv+mWJ713Gc6I4HhYa0MIKaVxHAEAEbwnPyMiAHAzIkLEbE7SYH8QHcCU7Lpuvb6uqqcYo9YDY5pzzhhTShljvidfUioAyohISllu7na7fQjeOTocPs7Ob+rtS0px/9ovL6vV6irP87qum6YpimKxuLh/eHx715n3nvPPsrxt2zaE0VrrnH/eMmPQEQ4DCKG1Vkopa60xRgjR971SWmtzqp1SCiHADBFjnEYBIADQn+NT/jcT0S8Oqg/G6zJEqAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": " ",
            "title": " ",
            "src": "/version/4.9.1/static/8c70b4b0b041b9e0ad0cbc398ea35458/e3189/Tooltip-positions.png",
            "srcSet": ["/version/4.9.1/static/8c70b4b0b041b9e0ad0cbc398ea35458/a2ead/Tooltip-positions.png 259w", "/version/4.9.1/static/8c70b4b0b041b9e0ad0cbc398ea35458/6b9fd/Tooltip-positions.png 518w", "/version/4.9.1/static/8c70b4b0b041b9e0ad0cbc398ea35458/e3189/Tooltip-positions.png 1035w", "/version/4.9.1/static/8c70b4b0b041b9e0ad0cbc398ea35458/44d59/Tooltip-positions.png 1553w", "/version/4.9.1/static/8c70b4b0b041b9e0ad0cbc398ea35458/6568d/Tooltip-positions.png 1660w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
      <hr></hr>
      <h2>{`Accessibility`}</h2>
      <p>{`Tooltips are displayed when hovering over or focusing on an element, but they are also announced to screen readers for the visually impaired. Users navigating the page with a keyboard will see the tooltip when they move focus to the element, and may dismiss the tooltip by pressing the `}<inlineCode parentName="p">{`Escape`}</inlineCode>{` key.`}</p>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      